export function getSafeRedirectPath(path: string | null | undefined): string | undefined {
  const trimmedPath = path?.trim();
  if (!trimmedPath) return undefined;
  if (!trimmedPath.startsWith("/") || trimmedPath.startsWith("//")) return undefined;
  if (trimmedPath.includes("\\")) return undefined;

  const isLoginPath =
    trimmedPath === "/login" ||
    trimmedPath.startsWith("/login/") ||
    trimmedPath.startsWith("/login?");
  if (isLoginPath) return undefined;

  return trimmedPath;
}
